'use client'
import { setWasmUrl } from '@lottiefiles/dotlottie-react'

export default function DotLottieInit() {
  //useEffect(() => {
  //  setWasmUrl('/lottie/dotlottie-player.wasm');
  //}, []);
  setWasmUrl('/lottie/dotlottie-player.wasm')
  return null
}
